import { AlertCircle } from 'lucide-react'

export const CliAuthError = () => (
  <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-background">
    <div className="flex h-16 w-16 items-center justify-center rounded-full bg-red-100">
      <AlertCircle className="h-8 w-8 text-red-600" />
    </div>
    <h1 className="text-2xl font-semibold">Failed to send credentials to CLI</h1>
    <p className="max-w-md text-center text-muted-foreground">
      The CLI process may have stopped. Please go back to your terminal and run the command again.
    </p>
  </div>
)
